import React, { PureComponent } from "react";
import { Select, Radio, Checkbox, Button } from "element-react";
import { List,Input } from "antd";
import { Link } from "react-router-dom";
import { showhtml } from 'utils/methods';
import Navigation from "../../components/navigation";

import Request from "../../networkReq/request";
import Http from "../../networkReq/http"

import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: '',
      active: 1
    };
  }

  componentDidMount() {
    this.fetchall({ id: '1419616438688497666', tenantId: "" });
  }

  fetchall = (values) => {
    Http.get(Request.detailModel(), values, obj => {
      if (obj.code == 200) {
        this.setState({
          data: obj.data.content
        })
      }
    });
  }

  fetchother = (values) => {
    Http.get(Request.detailModel(), values, obj => {
      if (obj.code == 200) {
        this.setState({
          data: obj.data.content
        })
      }
    });
  }

  handleTabs = (activekey) => {
    this.setState({ active: activekey })
    if (activekey == 1) {
      this.fetchall({ id: '1419616438688497666', tenantId: "" });
    } else {
      this.fetchother({ id: '1419616806134693889', tenantId: "" });
    }
  }

  render() {
      const { data, active } = this.state;
    return (
      <div className="city">
        <Navigation />
        <div className="city-header">
          <div className="city-container">
            <div className="city-title">双拥模范城展示</div>
            <div className="city-layout city-tabs">
              <div onClick={() => this.handleTabs(1)} className={`tab ${active==1? "tab-active":""} `}>全国双拥模范城展示</div>
              <div onClick={() => this.handleTabs(2)} className={`tab ${active==2? "tab-active":""} `}>自治区双拥模范城展示</div>
            </div>
          </div>
        </div>
        <div className="city-container city-content">{showhtml(data)}</div>
      </div>
    );
  }
}
